import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAdsConsent } from "@/lib/consent";
import { track, revokePixel } from "@/lib/metaPixel";

export const MetaRouteTracker = () => {
  const location = useLocation();
  const ads = useAdsConsent();
  const last = useRef(null);
  const wasGranted = useRef(ads);

  useEffect(() => {
    if (!ads) {
      if (wasGranted.current) revokePixel();
      wasGranted.current = false;
      last.current = null;
      return;
    }
    wasGranted.current = true;
    const key = location.pathname + location.search;
    if (location.pathname.startsWith("/admin") || last.current === key) return;
    if (track("PageView")) last.current = key;
  }, [ads, location.pathname, location.search]);

  return null;
};
